import { ReactNode } from 'react';
import {
  Button as AriaButton,
  Tooltip as AriaTooltip,
  TooltipTrigger as AriaTooltipTrigger,
} from 'react-aria-components';
import { Typography } from '../../atoms/typography/typography';
import { dialog } from '../../patterns/dialog';

type Props = {
  children: ReactNode;
  title?: string;
  content: ReactNode;
};

export function Tooltip(props: Props) {
  const { children, title, content } = props;

  return (
    <AriaTooltipTrigger delay={0}>
      <AriaButton>{children}</AriaButton>
      <AriaTooltip className={dialog()}>
        {title && (
          <Typography variant="body-s" weight="medium">
            {title}
          </Typography>
        )}
        <Typography variant="body-xs" weight="regular">
          {content}
        </Typography>
      </AriaTooltip>
    </AriaTooltipTrigger>
  );
}
